import React from 'react';
import { useAtom } from 'jotai';
import { SelectField } from '@wk/components-v3-react16';
import { workerFilterAtom } from '../../atoms';
import { useCsbWorkers } from './useCsbWorkers';
import styles from './ModuleFilter.module.scss';

// Native <select> popups size themselves to fit the widest option and ignore CSS truncation
const MAX_WORKER_LABEL_LENGTH = 30;
const truncateWorkerLabel = (worker: string) =>
  worker.length > MAX_WORKER_LABEL_LENGTH
    ? `${worker.slice(0, MAX_WORKER_LABEL_LENGTH)}…`
    : worker;

export const ModuleFilter = () => {
  const [selectedWorker, setSelectedWorker] = useAtom(workerFilterAtom);
  const { data: workers = [], isLoading } = useCsbWorkers();

  return (
    <div className={styles.moduleFilter}>
      <SelectField
        srLabel="Select CSB Worker"
        size="large"
        labelFor="worker-filter"
      >
        <select
          id="worker-filter"
          value={selectedWorker}
          disabled={isLoading}
          onChange={(event) => setSelectedWorker(event.target.value)}
        >
          <option value="">Select CSB Worker</option>
          {workers.map((worker) => (
            <option key={worker} value={worker} title={worker}>
              {truncateWorkerLabel(worker)}
            </option>
          ))}
        </select>
      </SelectField>
    </div>
  );
};

export default ModuleFilter;
